const REGIONS = {
  GLOBAL: 'global',
  SCANDINAVIA: 'scandinavia'
}

const ROOT_URL = process.env.NEXT_PUBLIC_ROOT_URL || 'http://ultramagnus.willandskill.eu:9001'
const isDev = process.env.isDev == "true" || false


const REGION = process.env.NEXT_PUBLIC_REGION || REGIONS.SCANDINAVIA

const REGION_SETTINGS_LIST = {
  global: {
    startUrl: '/uae',
    domain: 'https://www.investoract.com',
    brand: {
      name: 'InvestorAct',
      shortDescription: 'Stay ahead of of the curve with our daily financial updates!',
      description: 'InvestorAct is a financial news platform that provides the latest news, analysis, and press releases for companies in the UAE',
      brandNameAndSymbol: '/images/brand-name-and-symbol.svg',
      brandSymbol: '/images/brand-symbol.svg'
    },
    ads: {
      sunt: {
        showOnOverviewPage: false,
        showOnECList: false,
        showOnECListModulo: 3,
      }

    }

  },
  scandinavia: {
    startUrl: '/sv',
    domain: 'https://www.bors360.com',
    brand: {
      name: 'Börs360',
      shortDescription: 'Håll dig uppdaterad med de senaste analyserna!',
      description: 'Senaste analyserna, nyheterna, pressmeddelande för bolag i Sverige',
      brandNameAndSymbol: '/images/bors360/brand-name-and-symbol-white.svg',
      brandSymbol: '/images/bors360/brand-symbol-white.svg'
    },
    ads: {
      sunt: {
        showOnOverviewPage: false,
        showOnECList: false,
        showOnECListModulo: 3,
      }

    }
  }
}

const REGION_SETTINGS = REGION_SETTINGS_LIST[REGION]
const GA_TM_ID = process.env.NEXT_PUBLIC_GA_TM_ID || 'GTM-TWW22BDN'
const MATOMO_SITE_ID = process.env.MATOMO_SITE_ID

const BRAND = REGION_SETTINGS.brand
const DOMAIN = REGION_SETTINGS.domain
const AD_SETTINGS = REGION_SETTINGS.ads
const START_URL = REGION_SETTINGS.startUrl

const CACHE_SETTINGS = {
  REVALIDATE_PAGE_DEFAULT: 60*10, // 1 minute
  REVALIDATE_MAIN_PAGE: 60*15, // 15 minutes
  REVALIDATE_EDITORIAL_CONTENT_LIST: 60*10, // 10 minutes
  REVALIDATE_EDITORIAL_CONTENT_DETAIL: 60*30, // 30 minutes
  FETCH_CACHE: 60, // 1 minute
}

const COUNTRY_UAE_ID = 9
const COUNTRY_SWEDEN_ID = 1
const URL_SWEDEN_PREFIX = 'sv'
const URL_UAE_PREFIX = 'uae'

const LANGUAGES = {
  SWEDISH: 'sv',
  ENGLISH: 'en-gb'
}
const LANGUAGE = REGIONS.SCANDINAVIA === REGION ? LANGUAGES.SWEDISH : LANGUAGES.ENGLISH

export {
    AD_SETTINGS,
    BRAND, 
    CACHE_SETTINGS,
    COUNTRY_SWEDEN_ID,
    COUNTRY_UAE_ID,
    DOMAIN, 
    GA_TM_ID,
    isDev, 
    LANGUAGE,
    MATOMO_SITE_ID,
    REGION,
    REGIONS,
    ROOT_URL, 
    START_URL,
    URL_SWEDEN_PREFIX,
    URL_UAE_PREFIX,

}